import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react'
import { Well } from '@pushly/aqe/lib/components'
import { RelativeDelayPicker } from './relative-delay-picker'
import { DelayParams, DelayStep, JourneyNode, NodeEditorRef } from '../types/journey-nodes'
import { JourneyBuilderMode } from '../enums/journey-builder-mode.enum'
import { useJourneyContext } from '../context'

type DelayEditorProps = {
    node: JourneyNode<DelayStep>
}

export const DelayEditor = forwardRef<NodeEditorRef, DelayEditorProps>(({ node }, ref) => {
    const [state, _dispatch] = useJourneyContext()
    const [params, setParams] = useState(node.data.step.configuration.params)

    const handleDelayChange = useCallback(
        (changes: DelayParams) => {
            setParams(changes)
        },
        [node],
    )

    useImperativeHandle(ref, () => ({
        onSubmit: (): JourneyNode<DelayStep> => {
            node.data.setStep({
                ...node.data.step,
                configuration: {
                    ...node.data.step.configuration,
                    params,
                },
            })

            return node
        },
    }))

    return (
        <>
            <Well mode="ghost" title="Schedule" hideFooter={true}>
                <RelativeDelayPicker
                    disabled={state.mode === JourneyBuilderMode.READONLY}
                    value={params}
                    onChange={handleDelayChange}
                />
            </Well>
        </>
    )
})
